/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The OrderLineItemModifierResultModel model module.
* @module model/OrderLineItemModifierResultModel
* @version 1.0.0
*/
export default class OrderLineItemModifierResultModel {
    /**
    * Constructs a new <code>OrderLineItemModifierResultModel</code>.
    * @alias module:model/OrderLineItemModifierResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>OrderLineItemModifierResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/OrderLineItemModifierResultModel} obj Optional instance to populate.
    * @return {module:model/OrderLineItemModifierResultModel} The populated <code>OrderLineItemModifierResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderLineItemModifierResultModel();
                        
            
            if (data.hasOwnProperty('Name')) {
                obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
            }
            if (data.hasOwnProperty('Id')) {
                obj['Id'] = ApiClient.convertToType(data['Id'], 'String');
            }
            if (data.hasOwnProperty('BasePrice')) {
                obj['BasePrice'] = ApiClient.convertToType(data['BasePrice'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {String} Name
    */
    'Name' = undefined;
    /**
    * @member {String} Id
    */
    'Id' = undefined;
    /**
    * @member {Number} BasePrice
    */
    'BasePrice' = undefined;




}
